// import Swiper JS
import Swiper, {Navigation, Autoplay} from 'swiper';
// import Swiper styles
import 'swiper/css';
// import smoothscroll for Smooth Scroll behavior on Safari
import smoothscroll from 'smoothscroll-polyfill';

// GSAP (GreenSock Animation Platform)
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
window.gsap = gsap;

// configure Swiper to use modules
Swiper.use([Navigation, Autoplay]);

document.addEventListener("DOMContentLoaded", () => {
    // init smoothscroll
    smoothscroll.polyfill();


    // Simple configuration example for Swiper
    const swiper = new Swiper('.swiper', {
        // Optional parameters
        loop: true,
        speed: 700,
        spaceBetween: 15,
        slidesPerView: 1.2,
        grabCursor: true,
        centeredSlides: true,
        autoplay: {
            delay: 7000,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 1.4,
                spaceBetween: 25
            },
            1280: {
                slidesPerView: 1.6,
            },
        }
    });

    // Custom progress bar and add header class on scroll

    window.addEventListener("scroll", progressBar);
    let header = document.querySelector('header');

    function progressBar() {
        let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        let scrolled = (winScroll / height) * 100;
        document.getElementById("progressBar").style.width = scrolled + "%";
        if (window.pageYOffset < 50 && header.classList.contains('scroll')) {
            header.classList.remove('scroll');
        }
        if (window.pageYOffset >= 50 && !header.classList.contains('scroll')) {
            header.classList.add('scroll');
        }
    }



    // Impressum & Datenschutz opening on click

    let privacyLink = document.querySelectorAll('.imprint');

    const openBlock = (element) => {
        let block = document.querySelector(element.getAttribute('href'));
        let menuHeight_compensetion = document.querySelectorAll('header')[0].clientHeight;

        if (!block.classList.contains('d-none')) {
            let anchorBlock = document.querySelector('footer');
            let elementPosition = anchorBlock.offsetTop;
            let offsetPosition = elementPosition + anchorBlock.clientHeight - document.documentElement.clientHeight;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
            setTimeout(() => {
                block.classList.add('d-none');
            }, 1000)
        } else {
            block.classList.remove('d-none');
            let anchorBlock = block;
            let headerOffset = menuHeight_compensetion;
            let elementPosition = anchorBlock.offsetTop;
            let offsetPosition = elementPosition - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    }

    privacyLink.forEach((link, index) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            openBlock(e.target);
        })
    });

    // Get current year for copyright text

    let date = new Date();
    let year = date.getFullYear().toString();
    document.getElementById("year").innerText = year;

    //Show and hide progress bar

    const progressBarContainer = document.querySelector('.progress-bar__container');
    if(progressBarContainer) {
        window.addEventListener('scroll', ()=>{
            if(window.scrollY && !progressBarContainer.classList.contains('active')) {
                progressBarContainer.classList.add('active');
            } else if(!window.scrollY && progressBarContainer.classList.contains('active')) {
                progressBarContainer.classList.remove('active')
            }
        });
    }

    //Menu toggle

    const menuBtn = document.querySelector('.menu-toggle');
    const navList = document.querySelector('nav');
    const menuLinks = document.querySelectorAll('.menu-link');
    menuBtn.addEventListener('click', toggleMenu);
    menuLinks.forEach(el=>el.addEventListener('click', navClick));

    function toggleMenu() {
        menuBtn.classList.toggle('active');
        navList.classList.toggle('active');
        document.body.classList.toggle('menu-open');
    }

    function navClick(e) {
        e.preventDefault();
        toggleMenu();
        const sectionID = e.currentTarget.querySelector('a').getAttribute("href");
        const section = document.querySelector(sectionID);
        const offset = section.offsetTop - header.offsetHeight;
        window.scrollTo({
            top: offset,
            behavior: 'smooth' // Optional: Adds smooth scrolling effect
        });
    }

    gsap.to('.gsap-image', {
        bottom: 120,
        ease: "none",
        scrollTrigger: {
            scrub: 0.7,
            trigger: '.gsap-image',
            start: "top bottom",
            end: "bottom top",
        },
    });

    gsap.to('.gsap-parallax', {
        top: -50,
        ease: "none",
        scrollTrigger: {
            scrub: 0.7,
            trigger: '.gsap-parallax',
            start: "top bottom",
            end: "bottom top",
        },
    });

    gsap.to('.gsap-title', {
        top: 65,
        ease: "none",
        scrollTrigger: {
            scrub: 1,
            trigger: '.hero',
            start: "bottom bottom",
            end: "52% top",
        },
    });

    gsap.to('.gsap-appear-1', {
        opacity: 1,
        ease: "none",
        delay: 0.3,
        duration: 0.5,
    });

    gsap.to('.gsap-appear-2', {
        opacity: 1,
        ease: "none",
        delay: 1,
        duration: 0.5,
    });

    gsap.to('.gsap-appear-3', {
        opacity: 1,
        ease: "none",
        delay: 1.7,
        duration: 0.5,
    });

    // Make nav link active when section in viewport

    const navSections = document.querySelectorAll('.related-to-nav');

    navSections.forEach(el=>{
        ScrollTrigger.create({
            trigger: el,
            start: 'top 50%',
            end:'bottom 50%',
            onEnter: makeLinkActive,
            onEnterBack: makeLinkActive,
            // onLeave: makeLinkInactive,
            // onLeaveBack: makeLinkInactive,
        });
    })

    function makeLinkActive(e) {
        document.querySelectorAll('.menu-link>a').forEach(el=>el.classList.remove('active'));
        let href = '#' + e.trigger.id;
        document.querySelector(`.menu-link>a[href='${href}']`).classList.add('active');
    }

    function makeLinkInactive(e) {
        let href = '#' + e.trigger.id;
        document.querySelector(`.menu-link>a[href='${href}']`).classList.remove('active');
    }




});